export const zIndex = /** @type {const} */ ({
  cluster: 1,
  place: 2,
  placeInfo: 3,
});
